export const contactCustomerSuccess = () =>
  (window.location.href = 'mailto:customerteam@linearb.io');
